import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { STORAGE } from '../../../constant/storages';
import { ApiserviceService } from '../../../httpservice/apiservice.service';
import { BTN } from '../../../text_control/text_button';
import { _getStorage } from '../../../utils/local-storage';

@Component({
  selector: 'app-log-etax-detail',
  templateUrl: './log-etax-detail.component.html',
  styleUrls: ['./log-etax-detail.component.scss'],
})
export class LogEtaxDetailComponent implements OnInit {
  Active = 3;
  dataLog:any = []
  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";


  constructor(public router: Router, private alertController: AlertController, private apiService: ApiserviceService,) {
    this.dataLog = _getStorage(STORAGE.DATA_LOG_ETAX)
  }

  ngOnInit() { }
  ionViewDidEnter() {
    this.userID = _getStorage(STORAGE.userID);
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    
    if (this.userRole !== "ETAXSUPERADMIN" && this.userRole !== "SUPERADMIN") {
      this.router.navigate(["home"]);
      return;
    }

  }
  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: BTN.ok,
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }
  backpage() {
    this.router.navigate(['backoffice/log-etax'])

  }

  formatJson(item) {
    let json = JSON.parse(item)
    return json
  }
  async ErrorData(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: BTN.ok,
          cssClass: "alertButton",
          handler: (blah) => {
            this.router.navigate(['backoffice/log-etax'])
          }
        },
      ],
    });
    await alert.present();
  }
}
